import { useMemo, lazy } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RenderType, Screen, DynamicSingleViewPage, useConfig } from 'library';

import { RoutesConfig } from './config';
import Layout from '../layout/components/Layout';
import ProtectedRoute from '../components/ProtectedRoute';
import LoginPage from '../pages/LoginPage';

const AuthCallback = lazy(() => import('../pages/AuthCallback'));
const RimsAuth = lazy(() => import('../pages/RimsAuth'));
const PageNotFound = lazy(() => import('../pages/PageNotFound'));
const Home = lazy(() => import('../pages/Home'));
const NotificationRedirect = lazy(
  () => import('../pages/NotificationRedirect')
);

const AppRoutes = () => {
  const { routes: configRoutes } = useConfig();

  const indexRoute = configRoutes.find(r => r.path == RoutesConfig.Home.path);

  const routes = useMemo(
    () => [
      {
        path: '/',
        element: <ProtectedRoute />,
        children: [
          {
            path: RoutesConfig.NotificationRedirect.path,
            element: <NotificationRedirect />,
          },
          {
            element: <Layout />,
            children: [
              {
                index: true,
                element: indexRoute ? (
                  <Screen id={indexRoute.screenId!} />
                ) : (
                  <Home />
                ),
                path: RoutesConfig.Home.path,
              },
              ...configRoutes.map(route => ({
                path: route.path,
                element: route.screenId ? (
                  <Screen id={route.screenId} />
                ) : route.renderType === RenderType.DYNAMIC_SINGLE_VIEW ? (
                  <DynamicSingleViewPage />
                ) : undefined,
                key: route.id,
              })),
            ],
          },
        ],
      },
      {
        path: RoutesConfig.Auth.path,
        element: <ProtectedRoute isGuestRoute />,
        children: [{ index: true, element: <LoginPage /> }],
      },
      {
        path: RoutesConfig.AuthCallback.fullPath,
        element: <AuthCallback />,
      },
      {
        path: RoutesConfig.RimsAuth.path,
        element: <RimsAuth />,
      },
      {
        path: RoutesConfig.NotFound.path,
        element: <PageNotFound />,
      },
    ],
    [configRoutes]
  );

  const router = useMemo(() => createBrowserRouter(routes), [routes]);

  return <RouterProvider router={router} />;
};

export default AppRoutes;
